import { Link } from 'react-router';

interface Props {
  problem: string | null;
  done: string | null;
}

// Events leave through workers, so success points to where they show up
// instead of promising they already arrived.
export function SandboxOutcome({ problem, done }: Props) {
  if (problem) {
    return (
      <div role="alert" className="mt-3 text-sm text-[var(--co-error)]">
        {problem}
      </div>
    );
  }
  if (!done) return null;

  return (
    <div role="status" className="mt-3 text-sm text-[var(--co-success)]">
      {done} Follow the events in{' '}
      <Link to="/webhooks" className="underline">
        Webhooks
      </Link>{' '}
      and{' '}
      <Link to="/callback-logs" className="underline">
        Callback Logs
      </Link>
      .
    </div>
  );
}
